import ddt from '@wix/da-ddt';
import findIndex from 'lodash.findindex';
export function getFeature(type, features) {
    if (typeof features === 'string') {
        try {
            features = JSON.parse(features);
        }
        catch (e) {
            ddt.error('draftjs', 'Failed to parse journal features', e);
        }
    }
    if (typeof features === 'string') {
        return; // TS..
    }
    var idx = findIndex(features, ['type', type]);
    return features[idx] || undefined;
}
//# sourceMappingURL=helper.js.map